import { TaskListItem, TaskControlsAction } from '../../types/tasks.types';

export const TaskListItems = function(props: {
	tasksList: TaskListItem[],
	actionClick: (action: TaskControlsAction, taskTitle: string) => void,
	selectedClassCode: string,
	onClassCodeClick: (code: string) => void
}) {
	return props.tasksList.map((task, index) => {
		let displayTitle = task.taskTitle.replace(/_/g, ' ');
		return (
			<li className='teachers-task-listitem teachers-taskslist-fullitem' key={displayTitle+'-'+index}>
				<div>
					<span className='teachers-listitem-name'>{displayTitle}</span>
					{task.meta?.classCode && (
						<span
							className='teachers-listitem-classcode'
							onClick={() => props.onClassCodeClick(task.meta!.classCode)}
							style={{cursor: 'pointer'}}>
							{task.meta.classCode}
						</span>
					)}
				</div>
				<div className='teachers-listitem-buttons'>
					<button className='teachers-listitem-button teachers-listitem-button-view' onClick={() => {props.actionClick(TaskControlsAction.View, task.taskTitle);}}>View Info</button>
					{task.meta && <button className='teachers-listitem-button teachers-listitem-button-open' onClick={() => {props.actionClick(TaskControlsAction.Open, task.taskTitle);}}>Open Page</button>}
					<button className='teachers-listitem-button teachers-listitem-button-delete' onClick={() => {props.actionClick(TaskControlsAction.Delete, task.taskTitle);}}>Delete</button>
				</div>
			</li>
		);
	});
};
